<script lang="js" setup>
import { useTheme } from 'vuetify'

// Access the original (global) Vuetify theme name and pass it through
const { global: { name: originalTheme } } = useTheme()
</script>

<template>
  <VThemeProvider :theme="originalTheme">
    <slot></slot>
  </VThemeProvider>
</template>
